
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/third-litter",
      function () {
        return require("private-next-pages/third-litter/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/third-litter"])
      });
    }
  